<template>
  <div class="box">
    <div class="level">
      <div class="level-left tags">
        <span class="tag is-primary">
          <a href="">Info</a>
        </span>
        <span class="tag is-info">
          <a href="">Books</a>
        </span>
        <span class="tag is-danger">
          <a href="">Food</a>
        </span>
        <span class="tag is-warning">
          <a href="">Important</a>
        </span>
      </div>
      <div class="level-right tags">
        <span class="tag">
          <a href="">#TagOne</a>
        </span>
        <span class="tag">
          <a href="">#TagTwo</a>
        </span>
        <span class="tag">
          <a href="">#TagThree</a>
        </span>
        <span class="tag">
          <a href="">#TagFour</a>
        </span>
        <span class="tag">
          <a href="">#TagFive</a>
        </span>
      </div>
    </div>

    <p class="title has-text-centered">My wonderful article title</p>
    <p class="subtitle is-6 has-text-centered text-unimportant">
      <i class="fas fa-clock"></i>
      <time datetime="2018-03-16">16/03/2018 - 11:09 PM </time>
      by
      <a href="">@awesomewriter</a>
    </p>

    <p>
      <strong>Lorem </strong> ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
       tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
       exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
       in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
       sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est
       laborum.
    </p>
    <p>
      Integer sodales dolor sem, vel interdum justo porttitor eget. Vestibulum nec pretium lectus.
      Donec et arcu et eros pharetra auctor. Quisque vel ex consequat, finibus nisi non, fermentum
      purus. Donec velit lorem, euismod vitae odio ut, eleifend vehicula orci. Interdum et malesuada
      fames ac ante ipsum primis in faucibus. Phasellus consequat placerat nunc in finibus.
      Vestibulum accumsan ultrices mi tempor rutrum. Sed orci neque, egestas et sem a, porta
      sagittis tortor. Curabitur at consectetur odio. Suspendisse dui nibh, fringilla vel tellus
      sed, tempus rutrum nisl. Pellentesque habitant morbi tristique senectus et netus et malesuada
      fames ac turpis egestas. In fringilla lacinia vulputate.
    </p>
    <p>
      Integer vitae justo non lacus viverra volutpat. Donec et euismod lorem, ultricies tempus
      turpis. Donec nec posuere purus, et consectetur lorem. Fusce efficitur erat in molestie
      dapibus. Nulla facilisi. Etiam eget risus massa. Nam scelerisque rutrum risus, in euismod
      quam fermentum vel. Aliquam sit amet finibus lorem, eget vehicula nisl.
    </p>
    <p>
      Proin sit amet enim sem. Vivamus quis mi
      <strong>tristique</strong>, gravida odio ut, consequat augue. Mauris aliquet, quam et laoreet
      sagittis, eros nunc rhoncus massa, sed ultrices ligula enim vel magna. Fusce viverra tellus
      vel dapibus pharetra. Integer faucibus tortor quis nisl facilisis eleifend dignissim ut dui.
      Quisque egestas massa nec hendrerit tincidunt. Nunc posuere, augue ut commodo blandit, sapien
      arcu mollis arcu, vitae faucibus odio magna ut lacus. Class aptent taciti sociosqu ad litora
      torquent per conubia nostra, per inceptos himenaeos.
    </p>
    <p>
      Pellentesque feugiat eu purus ut dignissim. Morbi id purus quam. Maecenas vestibulum ex
      fringilla, rutrum ligula nec, sollicitudin metus. Fusce scelerisque dapibus venenatis. Cras
      sapien metus, lacinia nec nisl vel, maximus pharetra ligula. Proin mauris nibh, feugiat vel
      mauris non, varius tempor felis. Curabitur finibus nunc vel libero finibus condimentum sed at
      dui. Ut vestibulum tempus ultrices. Sed pulvinar est justo, a maximus nisi lacinia vel. In
      eleifend tortor non turpis vehicula, sed efficitur nisl mattis. Orci varius natoque penatibus
      et magnis dis parturient montes, nascetur ridiculus mus. Vivamus sed neque ac nunc vestibulum
      ultricies id quis urna. Proin semper lectus sit amet turpis congue, non varius nulla
      facilisis. Fusce dignissim odio fermentum gravida placerat.
    </p>

    <br>

    <div class="level">
      <div class="level-left">
        <a class="level-item" href="">
          <span class="icon is-small">
            <i class="fab fa-twitter"></i>
          </span>
        </a>
        <a class="level-item" href="">
          <span class="icon is-small">
            <i class="fab fa-facebook-f"></i>
          </span>
        </a>
        <a class="level-item" href="">
          <span class="icon is-small">
            <i class="fab fa-google-plus"></i>
          </span>
        </a>
        <a class="level-item" href="">
          <span class="icon is-small">
            <i class="fab fa-github"></i>
          </span>
        </a>
      </div>
      <div class="level-right">
        <div>
          <star-rating :star-size="25" :rating="4" :read-only="true"></star-rating>
        </div>
      </div>
    </div>

    <article class="media">
      <figure class="media-left">
        <figure class="image is-64x64 is-100x100-mobile is-centered">
          <img class="is-circle" :src="loggedUser.imageSrc" alt="">
        </figure>
      </figure>
      <div class="media-content">
        <div class="field">
          <p class="control">
            <textarea class="textarea" placeholder="Add a comment..."></textarea>
          </p>
        </div>
        <div class="field">
          <p class="control">
            <button class="button">Post comment</button>
          </p>
        </div>
      </div>
    </article>

    <p class="title is-4 comments-title">Comments({{ Object.keys(comments).length }}):</p>

    <div v-for="(comment, index) in comments" v-bind:key="index" class="box">
      <article class="media">
        <div class="media-left">
          <figure class="image is-64x64 is-100x100-mobile is-centered">
            <img class="is-circle" :src="comment.imageSrc" alt="">
          </figure>
        </div>
        <div class="media-content">
          <div class="content">
            <p>
              <strong>{{ comment.name }}</strong>
              <small>
                <a href="">@{{ comment.user }}</a>
              </small>
              <small>{{ comment.time }}</small>
              <br> {{ comment.text }}
            </p>
          </div>
          <nav class="level is-mobile">
            <div class="level-left">
              <a class="level-item">
                <span class="icon is-small">
                  <i class="fa fa-reply"></i>
                </span>
              </a>
              <a class="level-item">
                <span class="icon is-small">
                  <i class="fa fa-retweet"></i>
                </span>
              </a>
              <a class="level-item">
                <span class="icon is-small">
                  <i class="fa fa-heart"></i>
                </span>
              </a>
            </div>
          </nav>
        </div>
      </article>
    </div>
  </div>
</template>


<style>
.tags a {
  color: inherit;
}

p {
  /*font-size: 0.8em;*/
  padding-top: 0.3em;
  padding-bottom: 0.3em;
}

.box {
  padding-left: 2em;
  padding-right: 2em;
}

.text-unimportant {
  color: #969494;
}

.comments-title {
  margin-top: 1.5em;
  /*padding-bottom: 1em;*/
}

@media screen and (max-width: 768px) {
  .level-item {
    display: inline-block;
    float: center;
    margin-left: 2px;
    margin-right: 2px;
  }

  .level-item:not(:last-child) {
    margin-bottom: 0;
  }

  .level-left {
    /*float:left;*/
    /*float:center;*/

    /*display: inline-block;*/
    display: flex;
    justify-content: center;
  }

  .level-right {
    /*float:right;*/
    /*display: inline-block;*/
    display: flex;
    justify-content: center;
  }

  .media {
    display: block;
  }

  .image.is-64x64-mobile {
    height: 64px;
    width: 64px;
  }

  .image.is-100x100-mobile {
    height: 100px;
    width: 100px;
  }

  .image.is-centered {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>

<script>
import StarRating from 'vue-star-rating';

export default {
  components: {
    StarRating,
  },
  data() {
    return {
      ratingValue: 3,
      loggedUser:
      {
        name: 'Awesome developer',
        user: 'awesomedeveloper',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        time: '1m',
        imageSrc: require('./../../../../assets/img/people/person2.jpg'),
      },
      comments: [
        {
          name: 'Awesome developer',
          user: 'awesomedeveloper',
          text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
          time: '1m',
          imageSrc: require('./../../../../assets/img/people/person1.jpg'),
        },
        {
          name: 'John Smith',
          user: 'johnsmith',
          text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.',
          time: '10m',
          imageSrc: require('./../../../../assets/img/people/person3.jpg'),
        },
        {
          name: 'Awesome developer',
          user: 'awesomedeveloper',
          text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.',
          time: '20m',
          imageSrc: require('./../../../../assets/img/people/person2.jpg'),
        },
        {
          name: 'Awesome developer',
          user: 'awesomedeveloper',
          text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.',
          time: '27m',
          imageSrc: require('./../../../../assets/img/people/person1.jpg'),
        },
      ],
    };
  },
};
</script>

